import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import myCollectionsStore from '../../stores/myCollectionsStore'
import layerStore from '../../stores/layerStore'
import { Link } from 'react-router-dom'

import DeleteCollection from '#images/delete-collection.svg'
import CollectionUp from '#images/collection-up.svg'
import EmptyPlaylistCover from '#images/empty-playlist-cover.png'

@inject('modalStore')
@observer
class MyCollection extends Component {
  get collectionUrl() {
    const { seo_id, id } = this.props.collection;
    return `/collection/${seo_id || id}`
  }

  delete = (e) => {
    e.preventDefault()
    e.stopPropagation()

    layerStore.deleteCollectionId = this.props.collection.id
    this.props.modalStore.show('deleteCollection')
  }

  up = (e) => {
    const { id } = this.props.collection
    e.preventDefault()
    e.stopPropagation()
    myCollectionsStore.itemUp(id)
  }

  down = (e) => {
    const { id } = this.props.collection
    e.preventDefault()
    e.stopPropagation()
    myCollectionsStore.itemDown(id)
  }

  render() {
    const { huge_image_url, name, description, owned } = this.props.collection
    const { positionMenu } = this.props
    return (
      <Link
        to={this.collectionUrl}
        className='border-b border-gray-11 first-of-type:border-t hover:bg-gray-15 group'
      >
        <div className='flex h-[100px]'>
          <div className='flex'>
            <img
              src={huge_image_url || EmptyPlaylistCover}
              className='min-w-[100px] max-w-[100px] min-h-[100px] max-h-[100px] object-cover bg-gray-12'
            />
          </div>

          <div className='flex flex-col pl-2.5 pr-4 py-2 min-w-0 max-w-full'>
            <p className='text-[15px] leading-tight pt-1 line-clamp-2 font-bold break-words [word-break:break-word]'>{name}</p>
            <p
              className='line-clamp-3 leading-none mt-2 text-xs text-gray-3'
              dangerouslySetInnerHTML={{__html: description}}
            ></p>
          </div>

          {
            positionMenu && (
              <div className='flex flex-col ml-auto py-2 pr-1 invisible group-hover:visible min-w-fit'>
                {
                  owned && (
                    <div>
                      <img
                        src={DeleteCollection}
                        className='hover:brightness-200 w-[20px] h-[20px]'
                        onClick={this.delete}
                      />
                    </div>
                  )
                }
                <div className='flex flex-col items-center mt-auto'>
                  <img
                    src={CollectionUp}
                    className='hover:brightness-200'
                    onClick={this.up}
                  />
                  <img
                    src={CollectionUp}
                    className='rotate-180 mt-1 hover:brightness-200'
                    onClick={this.down}
                  />
                </div>
              </div>
            )
          }
        </div>
      </Link>
    )
  }
}

export default MyCollection
